// extracted by mini-css-extract-plugin
export var active = "Nav-module--active--5c546";
export var haveItems = "Nav-module--haveItems--f4a0c";
export var item = "Nav-module--item--c4976";
export var itemText = "Nav-module--itemText--f2813";
export var nav = "Nav-module--nav--607fe";
export var scroll = "Nav-module--scroll--68696";
export var wrapper = "Nav-module--wrapper--63d90";